module.exports = __webpack_public_path__ + "static/media/qoute.965ed23c.svg";